<template>
  <div style="">
    <!-- 轮播图模块 -->
    <div class="ht-280" style="display:flex">
      <!-- 轮播图 -->
      <!-- <div> -->
<!--        <a-carousel dotPosition="bottom" autoplay  style="width:717px;height:280px" class="aca" arrows dots-class="slick-dots slick-thumb">-->
<!--          <div>-->
<!--            <img src="../../../assets/ps44f83amrafbmt7ilf5ogb1d28m59gg2f70ee82de-9c84-486a-ac0c-537d1228630b.png" alt="13" style="width:100%;height:280px"  />-->
<!--          </div>-->
          <!-- <div style="width:717px;height:280px">
            <img  src="../../../assets/u=200993112,2290594594&fm=26&fmt=auto&gp=0.jpg" alt="13" style="width:100%;height:280px" />
          </div> -->
          <!-- 通知公告模块 -->
          <div class="ht-280 mr-4 white-bg bl br" style="height: 278px;width:717px;">
            <div class="ht-40" style="border-bottom:2px solid #CC0000;">
              <h3 class="primary-bg tzgg-title dis-ib ">通知公告</h3>
              <span class="fr mr-10 warning fs-14 cur-p lh-38" @click="gdgg()">查看更多>></span>
            </div>
            <table class="tzgg-table fl">
              <tr>
                <td class="bb br ">
                <div class="tzTitle">
                  当前无招聘批次，该网站已停用，启用时间另行通知
                </div>

                  <!-- <span class="fr mr-14 info">{{item.FBSJ}}</span> -->
                </td>
              </tr>
            </table>
            <!-- <table class="tzgg-table fl">
              <tr v-for="(item, index) in tableList2" :key="index">
                <td class="bb tzTitle" @click="$router.push({path:'/gg',query: {noticeid:item.TZID,fid:item.FID}})">
                <div class="tzTitle">
                  {{item.TZBT}}
                </div> -->

                  <!-- <span class="fr mr-14 info">{{item.FBSJ}}</span> -->
                <!-- </td>
              </tr>
            </table> -->
          </div>
<!--          <div>-->
<!--            <img src="../../../assets/u=1078342765,4097877154&fm=11&fmt=auto&gp=0.jpg" alt="13" style="width:100%;height:280px"  />-->
<!--          </div>-->
<!--        </a-carousel>-->
      <!-- </div> -->
      <!-- 登录模块 -->
      <div class="right-login dis-ib fr" v-show="!isLog">
        <h3 class="right-login-title primary-bg">用户登录：<br/>暂停使用</h3>
<!--        <div class="mg-14">-->
<!--          <label class="mb-16 dis-ib"><span class="mr-10">账&nbsp;&nbsp;&nbsp;号:</span><input placeholder="手机号" type="text" class="input-text" v-model="userName1"></label>-->
<!--          <label class="mb-16 dis-ib"><span class="mr-10">密&nbsp;&nbsp;&nbsp;码:</span><input type="password" class="input-text" v-model="password1"></label>-->
<!--          <label class="dis-bl"><span class="mr-9">验证码:&nbsp;&nbsp;</span><input type="text" class="yzmput input-text wi-96" v-model="yzm"><img class="yzm" @click="renderVerifyCodeImg" :src="yzIMG" alt=""></label>-->
<!--          <span class="fs-14 fr cur-p" @click="$router.push('/zhmm')">忘记密码?</span><br>-->
<!--          <button class="right-login-button warning-bg" @click="syLog">登录</button>-->
<!--          <button class="right-login-button primary-bg mt-10" @click="visible=true">注册</button>-->
<!--        </div>-->
      </div>
      <!-- 登录之后的用户模块 -->
      <div class="right-login dis-ib fr" v-show="isLog">
        <h3 class="right-login-title primary-bg">欢迎您：{{named}}</h3>
        <div class="mg-14">
          <div class="usertodo">
            <ul>
              <li @click="$router.push('/wdjl')">
                <div><img style="width:100%" src="../../../assets/psyz2sp4jln4t9d6lzfo4zyqe5uaxieo3pobaae1c86-82a1-4f58-a56a-2a2e2ed4c5c3.png" alt=""></div>
                <span>我的简历</span>
              </li>
              <li @click="$router.push({path:'/grzx',query: {step:2}})">
                <div><img style="width:100%" src="../../../assets/psthhc30colo806k59ic57qtth8rsjevk42d20931e3-ee64-4b0e-9fa3-076f7af198eb.png" alt=""></div>
                <span>已申请</span>
              </li>
              <li @click="$router.push({path:'/grzx',query: {step:1}})">
                <div><img style="width:100%" src="../../../assets/pstd1lwwvmk87gyxmge8geggub3y6i3525cf7c698d-ce73-4a2e-90e3-a9d4893ea924.png" alt=""></div>
                <span>我的通知</span>
              </li>
              <li @click="$router.push({path:'/grzx',query: {step:3}})">
                <div><img style="width:100%" src="../../../assets/psfcipswvitiuk8xxe1ltn26z5qjb7ptmv98eeaff5-d842-4511-bec8-7237d62ed095.png" alt=""></div>
                <span>我的收藏</span>
              </li>
            </ul>
          </div>
          <button class="zxbtn" @click="zhuxiao">注销</button>
        </div>
      </div>
    </div>
    <!-- 广告模块 -->
    <div class="mt-10">
      <a-row>
        <a-col :span="8"><img class="cur-p" style="width:98%" src="../../../assets/图层 6.png" alt="" @click="previewImage"></a-col>
        <a-col :span="8" class="ta-c"><img class="cur-p" style="width:98%" src="../../../assets/图层 7.png" alt=""></a-col>
        <a-col :span="8" class="ta-r"><img class="cur-p" style="width:98%" src="../../../assets/图层 13.png" alt=""></a-col>
      </a-row>
    </div>
    <!-- 新华社总社年度招考模块 -->
    <div class="mt-10">
      <div class="minht-40">
<!--        <h3 class="primary-bg tzgg-title dis-ib hs3" v-for="(item,i) in pici" :style="ind==i ? IndStyle : ''" :key="i" @click="throttleQueryJobByBatchId(item.batchid,i)">-->
<!--          <a-tooltip>-->
<!--            <template slot="title">-->
<!--              {{item.batchname}}-->
<!--            </template>-->
<!--            <span>{{item.batchname}}</span>-->
<!--          </a-tooltip>-->
<!--        </h3>-->
      </div>
<!--      <div class="zk-table mt-20" style="display:flex;flex-wrap: wrap">-->
<!--        <div v-for="(item1,index) in zkList.depList" :key="index" v-show="item1.joblist[0]">-->
<!--          <div class="bd mg-4 white-bg pd-10" style="float:left;width:300px;height:92%">-->
<!--            <a-tooltip>-->
<!--              <template slot="title">-->
<!--                {{item1.DEPTNAME}}-->
<!--              </template>-->
<!--              <span class="fs-16 primary mr-20" style="float:left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item1.DEPTNAME}}</span>-->
<!--            </a-tooltip>-->
<!--            <span class="fs-14 mr-10" style="line-height: 24px;" v-for="(item2, index) in item1.joblist" :key="index" @click="$router.push({path:'/gw',query: {jobID:item2.JOBID}})">-->
<!--              <a-tooltip>-->
<!--                <template slot="title">-->
<!--                  {{item2.JOBNAME}}-->
<!--                </template>-->
<!--                <span class="zwClass">{{item2.JOBNAME}}</span>-->
<!--              </a-tooltip>-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <!-- 占位 -->
    <div class="zhanwei"> </div>

    <!-- 注册弹窗 -->
    <regist :visible.sync="visible"></regist>


  </div>
</template>
<script>
import regist from '../compos/regist.vue'

import {encryptedData} from '../../../../../common/utils/Encryption/JSEncrypt'
import {debounce} from '../../../utils/throttle'
import { log } from 'util';

export default {
  components: {
    regist,
  },
  data () {
    return {
      //登录名称
      named:'',

      //存放验证码图片的路径
      yzIMG:'',
      //存放验证码的路径
      yzmData:'',


      // 这是渲染在首页的部分通知列表
      tableList1: [],
      tableList2: [],
      // 是否登录
      isLog: false,
      // 注册弹窗是否显示隐藏
      visible: false,
      //登录弹窗是否显示隐藏
      Logvisible:true,

      //用户名
      userName1:'',
      //密码
      password1:'',
      //验证码
      yzm:'',

      //批次列表
      pici:[

      ],


      // 招考职位
      zkList:{},

      //获取招考职位所有的单位id
      danweiId:null,
      //设置深红色的样式
      IndStyle: {backgroundColor: '#F32D26'},
      ind: null
    }
  },
  methods: {
     //点击了首页的登录
    syLog(){
      if(this.userName1==''){
        return this.$message.warning('请输入账号或手机号')
      }else if(this.password1==''){
        return this.$message.warning('请输入密码')
      }

      this.post({
        url:'checkCaptcha',
        data:{
          inputCode:this.yzm,
          codeKey:this.yzmData
        }
      },(res)=>{
        if(res.code===200){


          this.post({
          url: 'login',
          data:{
            userName:this.userName1,
            passWord:encryptedData(this.password1),
            logonType:1
          }
        }, (res) => {
            console.log(res);
            if(res.code!==200) return this.$message.warning(res.message)

            // console.log(encryptedData(this.password1));
            // console.log(this.userName1);
            // console.log(res);
            if(res.code===200){
              this.renderVerifyCodeImg()
              this.isLog=true
              // console.log(res);
              sessionStorage.setItem('BDSOFT-TOKEN',res.data.token)
              sessionStorage.setItem('a0d',res.data.user.id)
              clearTimeout(tokentimesd)
              var that=this
              var tokentimesd = setTimeout( function(){
                sessionStorage.removeItem('BDSOFT-TOKEN')
                sessionStorage.removeItem('aabb')
                sessionStorage.removeItem('a0d')
                sessionStorage.removeItem('named')
                that.$router.push('/sy')
                that.$message.warning('登录超时，请重新登录')
              }, 1800000);
              this.password1=''
              this.myResume()
            }
           })


        }else{
          this.renderVerifyCodeImg()
          return this.$message.warning('验证码输入错误')
        }
      })




    },
    gdgg(){
      alert('该招聘批次已结束，无法查看')
    },
    //页面打开加载部分通知列表
    getInfoList(pn,ps){
      this.post({
          url: 'informMore',
          data:{
            pageNum:pn,
            pageSize:ps
          }
      }, (res) => {
        // console.log(res);
        // if(wh=='a'){
          this.tableList1=res.data.list
        // }
        // else if(wh=='b'){
        //   this.tableList2=res.data.list
        // }
      })
    },
    //点击了注销
    zhuxiao(){
      sessionStorage.removeItem('BDSOFT-TOKEN')
      sessionStorage.removeItem('aabb')
      sessionStorage.removeItem('a0d')
      sessionStorage.removeItem('named')
      this.isLog=false
    },
    //查询发布批次
    getChooseBatch(){
      var that=this
      this.get({
        url:'getChooseBatch',
      },(res)=>{
        console.log(res);
        console.log(999);
        if(res.code===200){
          this.pici=res.data.list
          this.queryJobByBatchId(res.data.list[0].batchid)
        }
      })
    },
    throttleQueryJobByBatchId: debounce( function (id,i) {
      try {
        this.queryJobByBatchId(id,i)
      } catch (e) {
        return false
      }
    }, 1000),
    //单位及职位
    queryJobByBatchId(id,i){
      this.ind=i
      this.post({
        url:'queryJobByBatchId',
        data:{
          bantchId:id
        }
      },(res)=>{
        console.log(res);
        if(res.code===200){
          console.log(res);
          this.zkList=res.data
          console.log(this.zkList);
        }
      })
    },


    // // 查询发布批次下的单位信息
    // getCurrentBantchDeplist(i){
    //   this.post({
    //     url:'getCurrentBantchDeplist',
    //     data:{
    //       batchid:i
    //     }
    //   },(res)=>{
    //     this.zkList.gw=[]
    //     console.log(res);
    //     if(res.code===200){
    //       this.zkList.title=res.data
    //       var a =  this.zkList.title.map(i => {
    //         return i.departmentid
    //       });
    //       var that=this
    //       console.log(a);
    //       // 循环单位的id，每循环一次就调一次(这样写可以让单位与职位一一对应)
    //         if(sss){
    //           sss=-1
    //         }
    //         var sss=-1
    //         a.forEach(i => {
    //           sss=sss+1
    //           that.jobSearch(i,sss)
    //         });
    //     }
    //   })
    // },
    // //根据单位信息查询职位信息
    // jobSearch(i,sss){
    //   this.post({
    //     url:'jobSearch',
    //     data:{
    //       depid:i,
    //       pageNum:1,
    //       pageSize:10
    //     }
    //   },(res)=>{
    //     if(res.code===200){
    //       this.zkList.title[sss].gw=res.data.list
    //       console.log(this.zkList);
    //     }
    //   })
    // },

    //获取验证码信息
    renderVerifyCodeImg(){
       this.post({
        url:'renderVerifyCodeImg',
      },(res)=>{
        this.yzIMG=res.data.base64Img
        this.yzmData=res.data.captchaKey
      })
    },

    //广告图片预览
    previewImage(){
      this.post({
          url: 'previewImage',
          data:{
            fid:'8146ed57bb6d427e9b9ba93edb5ed44b'
          }
      }, (res) => {
        // console.log(res);
      })
    },


     //获取简历人员信息
    myResume(){
      this.post({
        url:'myResume'
      },(res)=>{
        sessionStorage.setItem('named',res.data.a0101)
        sessionStorage.setItem('aabb',res.data.a00)
        this.named=sessionStorage.getItem('named')
      })
    },
    // 关闭弹窗
    cancel(){
      this.showVisible=false
      this.$emit('update:visible',false)
    },

  },

  created () {
     // 获取token判断是否登录
    var token = sessionStorage.getItem('BDSOFT-TOKEN')
    if(token){
      this.isLog=true
    }

    this.getInfoList(1,7)
    // this.getInfoList(2,4,'b')
    this.getChooseBatch()
    // this.queryJobByBatchId()
    // this.getCurrentBantchDeplist(1)


    this.renderVerifyCodeImg()

   if(sessionStorage.getItem('BDSOFT-TOKEN')){
    this.myResume()
   }
  }
}
</script>

<style lang="less" scoped>
li{
  list-style: none;
}
button{
  cursor: pointer;
}
.right-login {
  width: 283px;
  height: 279px;
  background: #FFFFFF;
  border: 1px solid #C7C7C7;
  border-radius: 5px 5px 0px 0px;
}
// 用户登录标题
.right-login-title{
  border-radius: 5px 5px 0px 0px;
  height: 76px;
  line-height: 38px;
  font-size: 16px;
  color: #fff;
  padding-left: 10px;
}
// 用户登录的input框
.input-text {
  border:1px solid #C7C7C7;
  width: 196px;
  height: 25px;
  line-height: 25px;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  overflow: hidden;
}
.right-login-button {
  width: 255px;
  height: 32px;
  color: #fff;
  border: 0;
}
// 通知公告模块表格
.tzgg-table {
  width: 100%;
}
.tzgg-table td{
  font-size: 14px;
  height: 35px;
  border-left: 0;
  padding-left: 15px;
  cursor: pointer;
}
.tzgg-title {
  border-radius: 5px 5px 0px 0px;
  height: 39px;
  line-height: 39px;
  text-align: center;
  max-width: 190px;
  padding-left: 20px;
  padding-right: 20px;
  -webkit-border-radius: 5px 5px 0px 0px;
  -moz-border-radius: 5px 5px 0px 0px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
  cursor: pointer;
}
.hs3{
  margin-bottom: -5px;
}
.minht-40{
  border-bottom: 2px solid #CC0000!important;
}
table{
table-layout: fixed;
}
.tzTitle{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 10px;
}
// 招考模块
.zk-table {
  width: 100%;
}
.zk-table td {
  width: 33.3%;
  display:inline-block;
}
.zk-table td div span{
  cursor: pointer;
}
//用户登录操作

.usertodo ul li{
  float: left;
  width: 120px;
  text-align: center;
  margin-bottom: 1px;
  cursor: pointer;
}
.usertodo ul li div{
  display: block;
  margin: 0 auto;
  width: 70px;
  height: 70px;
  line-height: 70px;
}
.usertodo ul li span{
  display: inline-block;
    margin: 0 auto;
    color: #016bb9;
    font-size: 14px;
}
.yzmput{
  width: 100px!important;
}
.yzm{
  display: inline-block;
    font-size: 14px;
    cursor: pointer;
    width: 75px;
    height: 30px;
    border: 1px solid black;
    margin-left: 20px;
    vertical-align: middle;
}
.zxbtn{
  width: 100%;
    height: 32px;
    font-size: 14px;
    color: #fff;
    display: block;
    border: none;
    background-color: #cc0000;
    font-family: "\5FAE\8F6F\96C5\9ED1", "\5B8B\4F53";
    cursor: pointer;
}
.asp{
  background-color: red;
  width: 10px;
  height: 10px;
  position: relative;
  bottom: 30px;
  border-radius: 50%;
}

.zhanwei{
  position:static;
  width: 100%;
  height: 200px;
}
.zwClass{
  display: block;
  float: left;
  width: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  padding-right: 5px;
}

/deep/ .slick-current{
  height: 280px!important;
}

</style>



// WEBPACK FOOTER //
// src/views/sy/pages/index.vue